export default __webpack_public_path__ + "static/media/Helm of Indra.516e2a65.jpg";